import clsx from 'clsx';
import { useState } from 'react';
import { Icon } from '../icon/icon.component';
import { style } from './copy-button.module.css';

interface Props {
  text: string;
  className?: string;
}

export function CopyButton(props: Props) {
  const { text, className } = props;
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(text).then(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 1000);
    });
  };

  return (
    <div className={clsx(style.container, className)}>
      <div className={style.button} onClick={handleCopy}>
        <Icon icon='content_copy' className={style.icon} />
      </div>
      <div className={clsx(style.tooltip, showTooltip && style.tooltipShow)}>
        Copiado
      </div>
    </div>
  );
}
